'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/url/~/querystring/index.js
// module id = 1076
// module chunks = 0